/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IssueCreator
 */
export interface IssueCreator {
    /**
     * 
     * @type {string}
     * @memberof IssueCreator
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof IssueCreator
     */
    readonly firstName: string;
    /**
     * 
     * @type {string}
     * @memberof IssueCreator
     */
    readonly lastName: string;
}

/**
 * Check if a given object implements the IssueCreator interface.
 */
export function instanceOfIssueCreator(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;

    return isInstance;
}

export function IssueCreatorFromJSON(json: any): IssueCreator {
    return IssueCreatorFromJSONTyped(json, false);
}

export function IssueCreatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): IssueCreator {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
    };
}

export function IssueCreatorToJSON(value?: IssueCreator | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

